import React from 'react';
import { motion } from 'framer-motion';
const screens = [{
  title: 'Balance Score',
  image: 'https://cdn.magicpatterns.com/uploads/b7jm8ZVc1ZpU7zCTkx4gfi/balance_score.png'
}, {
  title: 'Screen Time',
  image: 'https://cdn.magicpatterns.com/uploads/kUUbMc9L88mhNzKGCm8Kvy/web03.png'
}, {
  title: 'Blocking',
  image: 'https://cdn.magicpatterns.com/uploads/s6371t1pupsehtmFKsfVTm/web04.png'
}, {
  title: 'Milestones',
  image: 'https://cdn.magicpatterns.com/uploads/iwdKQfoZPLytMKTgX7vr4e/web05.png'
}, {
  title: 'Focus Session',
  image: 'https://cdn.magicpatterns.com/uploads/3DB6NS9GVBhR1EASdL2AoW/web06.png'
}, {
  title: 'Focus Timer',
  image: 'https://cdn.magicpatterns.com/uploads/9gU1A5k2BPYpdp5oZD7sWz/web07.png'
}];
// Triple the screens for seamless infinite loop
const loopedScreens = [...screens, ...screens, ...screens];
// Card width + gap
const cardWidth = 260;
const gap = 32;
const singleSetWidth = screens.length * (cardWidth + gap);
export function AppPreviewSection() {
  return <section className="py-24 bg-pond-dark overflow-hidden" data-id="element-1">
      <div className="max-w-7xl mx-auto px-6 mb-16" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-serif text-pond-cream mb-3" data-id="element-4">
            Designed for calm
          </h2>
          <p className="text-pond-cream-muted text-lg" data-id="element-5">
            Every screen crafted with intention
          </p>
        </motion.div>
      </div>

      {/* Infinite scrolling carousel */}
      <div className="relative" data-id="element-6">
        <motion.div className="flex gap-8" initial={{
        x: 0
      }} animate={{
        x: -singleSetWidth
      }} transition={{
        x: {
          duration: 30,
          repeat: Infinity,
          ease: 'linear',
          repeatType: 'loop'
        }
      }} data-id="element-7">
          {loopedScreens.map((screen, index) => <div key={index} className="flex-shrink-0" data-id="element-8">
              <div className="w-[260px] h-[540px] bg-gradient-to-b from-gray-800 to-gray-900 rounded-[40px] p-2 shadow-xl" data-id="element-9">
                <div className="w-full h-full rounded-[34px] overflow-hidden bg-black" data-id="element-10">
                  <img src={screen.image} alt={screen.title} className="w-full h-full object-cover object-top" data-id="element-11" />
                </div>
              </div>
            </div>)}
        </motion.div>
      </div>
    </section>;
}